import styled from 'styled-components';
import { ui } from './tokens';

// Option panel shown under the drawing tool bar for tools with settings
// (shapes, fill, grid, save, move). Same dark rounded surface as the bars.
export const Panel = styled.section`
	margin-top: 12px;
	padding: 14px 16px 16px;
	background-color: ${ui.bar};
	border-radius: 12px;
	font-family: ${ui.font};
	color: ${ui.text};
`;

export const PanelTitle = styled.h3`
	margin: 0;
	font-size: 14px;
	font-weight: 600;
`;

export const PanelHint = styled.p`
	margin: 2px 0 0;
	font-size: 11px;
	color: ${ui.label};
`;

export const SectionLabel = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	margin: 12px 0 6px;
	font-size: 9px;
	font-weight: 700;
	text-transform: uppercase;
	color: ${ui.label};
`;

export const PanelHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 10px;
`;

/** Small dark button with an optional colour swatch, e.g. "Colour" / "2 x 2" */
export const ChipButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
	background-color: ${ui.input};
	color: ${ui.text};
	border: none;
	border-radius: 6px;
	padding: 7px 10px;
	font-family: ${ui.font};
	font-size: 11px;
	font-weight: 600;
	cursor: pointer;

	&:active {
		transform: scale(0.97);
	}
`;

export const Swatch = styled.span<{ $color: string }>`
	width: 16px;
	height: 16px;
	border-radius: 4px;
	border: 1px solid ${ui.label};
	background-color: ${props => props.$color};
`;

export const Segmented = styled.div`
	display: flex;
	width: 100%;
	background-color: ${ui.bar};
	border-radius: 8px;
	padding: 3px;
	gap: 3px;
`;

export const SegmentButton = styled.button.withConfig({
	shouldForwardProp: prop => prop !== 'active',
})<{ active: boolean }>`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
	padding: 7px 8px;
	border-radius: 6px;
	border: none;
	background-color: ${props => (props.active ? ui.gold : 'transparent')};
	color: ${props => (props.active ? ui.onGold : ui.label)};
	font-family: ${ui.font};
	font-size: 11px;
	font-weight: ${props => (props.active ? 600 : 400)};
	cursor: pointer;
	transition: background-color 0.15s;

	&:active {
		transform: scale(0.97);
	}
`;
